module.exports = __webpack_public_path__ + "static/media/thumb_shield-fallback.5688c01f.png";